import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { MapPin } from 'lucide-react';

export default function AreaSelector({ selectedArea, onAreaChange, areas }) {
  const selectedAreaData = areas?.find(a => a.id === selectedArea);
  
  return (
    <div className="mb-6">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-teal-50 flex items-center justify-center">
            <MapPin className="w-5 h-5 text-teal-600" />
          </div>
          <div>
            <h2 className="font-semibold text-slate-900">
              {selectedAreaData?.name || 'Overvåkingsområde'}
            </h2>
            <p className="text-xs text-slate-500">
              {selectedAreaData 
                ? `${selectedAreaData.region} · ${selectedAreaData.locations?.length || 0} målepunkter`
                : 'Velg et område'
              }
            </p>
          </div>
        </div>
        
        <Select value={selectedArea} onValueChange={onAreaChange}>
          <SelectTrigger className="w-[200px] h-9 text-sm border-slate-200">
            <SelectValue placeholder="Velg område" />
          </SelectTrigger>
          <SelectContent>
            {areas.map((area) => (
              <SelectItem key={area.id} value={area.id}>
                {area.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
